export default {
  setToggleGrowthHeight (state:any, flag: boolean) {
    state.toggleGrowthHeight = flag
  },
  setToggleSoilMoisture (state:any, flag: boolean) {
    state.toggleSoilMoisture = flag
  },
  setCheckboxes (state: any, check: any[]) {
    state.checkboxes = check
  },
  setShowComparison  (state:any, flag: boolean) {
    state.showComparison = flag
  },
  setChangeComparisonGraph (state:any, flag: boolean) {
    state.getComparisonData = flag
  },
  setHiddenComparisonData (state:any, flag: boolean) {
    state.hiddenComparisonData = flag
  }
}
